import React, { PureComponent } from 'react'
import styled from 'styled-components'
import closeIcon from '../../assets/icons/close-icon.svg'
import { IAsset } from '../../helpers/data/question'

const Wrapper = styled.div`
	width: 100%;
	height: 100%;
	position: absolute;
	top: 0;
	left: 0;
	z-index: 1010;
`

const Veil = styled.div`
	width: 100%;
	height: 100%;
	background: rgba(21, 45, 57, 0.9);
	position: absolute;
	top: 0;
	left: 0;
`

const Container = styled.div`
	width: 90%;
	height: 90%;
	margin: auto;
	text-align: center;
	transform: translate(-50%, -50%);
	position: absolute;
	top: 50%;
	left: 50%;

	&::before {
		height: 100%;
		content: '';
		display: inline-block;
		vertical-align: middle;
	}
`

const CloseButton = styled.button`
	width: 25px;
	height: 25px;
	background: none;
	border: none;
	cursor: pointer;
	font-size: 0;
	padding: 0;
	position: absolute;
	top: 35px;
	right: 0;
	z-index: 1001;
`

const Image = styled.img`
	width: 95%;
	height: 95%;
	object-fit: contain;
	vertical-align: middle;
`

interface IImagePreviewProps {
	onClose?: () => void
	asset: IAsset
}

class ImagePreview extends PureComponent<IImagePreviewProps> {
	render() {
		return (
			<Wrapper onClick={this.props.onClose}>
				<Veil />
				<Container>
					<CloseButton>
						<img src={closeIcon} />
					</CloseButton>
					<Image
						src={this.props.asset.source}
						alt={!this.props.asset.isDecorative ? this.props.asset.altText || 'Reference Image' : ''}
						aria-hidden={this.props.asset.isDecorative}
					/>
				</Container>
			</Wrapper>
		)
	}
}

export default ImagePreview
